(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_step"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('steep-timer')) {
    customElements.define(
      'steep-timer',
      class SteepTimer extends HTMLElement {
        connectedCallback() {
          this.launchBtn = this.querySelector('[data-launch]');
          this.timeEl = this.querySelector('[data-time]');
          this.progressEl = this.querySelector('.timer__progress');
          this.toggleBtn = this.querySelector('[data-toggle]');
          this.resetBtn = this.querySelector('[data-reset]');
          this.soundBox = this.querySelector('[data-sound]');
          this.doneEl = this.querySelector('[data-done]');
          this.announceEl = this.querySelector('[data-announce]');
          this.radios = [...this.querySelectorAll('input[type="radio"]')];

          this.endAt = null;
          this.interval = null;
          this.setDuration(Number(this.dataset.minutes) || 5);

          this.launchBtn.addEventListener('click', () => {
            this.open();
            this.start();
          });
          this.toggleBtn.addEventListener('click', () => this.toggle());
          this.resetBtn.addEventListener('click', () => this.reset());
          this.radios.forEach((radio) =>
            radio.addEventListener('change', () => {
              if (!radio.checked) return;
              const wasRunning = this.isRunning();
              this.stopClock();
              this.setDuration(Number(radio.value));
              if (wasRunning) this.start();
            })
          );
          this.soundBox.addEventListener('change', () => {
            if (this.soundBox.checked) this.unlockAudio();
          });
          this.onVisible = () => {
            if (this.isRunning()) this.tick();
          };
          document.addEventListener('visibilitychange', this.onVisible);
        }

        disconnectedCallback() {
          clearInterval(this.interval);
          document.removeEventListener('visibilitychange', this.onVisible);
        }

        isRunning() {
          return this.endAt !== null;
        }

        open() {
          this.classList.add('is-open');
          this.launchBtn.setAttribute('aria-expanded', 'true');
          this.toggleBtn.focus({ preventScroll: true });
        }

        close() {
          this.classList.remove('is-open');
          this.launchBtn.setAttribute('aria-expanded', 'false');
          this.launchBtn.focus({ preventScroll: true });
        }

        setDuration(minutes) {
          this.duration = minutes * 60000;
          this.remaining = this.duration;
          this.doneEl.hidden = true;
          this.render(this.remaining);
        }

        toggle() {
          if (this.isRunning()) {
            this.pause();
          } else {
            this.start();
          }
        }

        start() {
          if (this.remaining <= 0) {
            this.remaining = this.duration;
            this.doneEl.hidden = true;
          }
          if (this.soundBox.checked) this.unlockAudio();
          const fresh = this.remaining === this.duration;
          this.endAt = Date.now() + this.remaining;
          this.interval = setInterval(() => this.tick(), 250);
          this.toggleBtn.textContent = this.dataset.pauseLabel;
          if (fresh) {
            this.announce(this.dataset.startedText.replace('[minutes]', String(Math.round(this.duration / 60000))));
          }
          this.tick();
        }

        pause() {
          this.remaining = Math.max(0, this.endAt - Date.now());
          this.stopClock();
          this.toggleBtn.textContent = this.dataset.resumeLabel;
          this.render(this.remaining);
        }

        reset() {
          this.stopClock();
          const checked = this.radios.find((radio) => radio.checked);
          this.setDuration(checked ? Number(checked.value) : Number(this.dataset.minutes) || 5);
          this.toggleBtn.textContent = this.dataset.pauseLabel;
          this.close();
        }

        stopClock() {
          clearInterval(this.interval);
          this.interval = null;
          this.endAt = null;
        }

        tick() {
          if (!this.isRunning()) return;
          const left = Math.max(0, this.endAt - Date.now());
          this.render(left);
          if (left === 0) this.finish();
        }

        finish() {
          this.stopClock();
          this.remaining = 0;
          this.toggleBtn.textContent = this.dataset.againLabel;
          this.doneEl.hidden = false;
          this.announce(this.dataset.readyText);
          if (this.soundBox.checked) this.chime();
        }

        render(left) {
          const totalSeconds = Math.ceil(left / 1000);
          const minutes = Math.floor(totalSeconds / 60);
          const seconds = totalSeconds % 60;
          this.timeEl.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
          const progress = this.duration ? 1 - left / this.duration : 0;
          this.progressEl.style.strokeDashoffset = String(1 - progress);
        }

        announce(text) {
          this.announceEl.textContent = '';
          window.setTimeout(() => {
            this.announceEl.textContent = text;
          }, 50);
        }

        unlockAudio() {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (!AudioCtx) return;
          if (!this.audio) this.audio = new AudioCtx();
          if (this.audio.state === 'suspended') this.audio.resume();
        }

        chime() {
          if (!this.audio) return;
          const now = this.audio.currentTime;
          [659.25, 987.77].forEach((frequency, i) => {
            const osc = this.audio.createOscillator();
            const gain = this.audio.createGain();
            osc.type = 'sine';
            osc.frequency.value = frequency;
            const start = now + i * 0.35;
            gain.gain.setValueAtTime(0, start);
            gain.gain.linearRampToValueAtTime(0.12, start + 0.03);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + 1.8);
            osc.connect(gain).connect(this.audio.destination);
            osc.start(start);
            osc.stop(start + 1.9);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
